<template>
  <div class="col px-0 px-md-3">
    <ColorPointsHeader :message="greenHeaderMessage" color="rgba(190, 206, 35, 0.5)" />
    <div class="row center my-5">
      <div class="col-12 mt-0 mt-md-5">
        <h3 class="text-center text-primary openSans-bold" v-html=" focus.paragraphe1 ? focus.paragraphe1.titre : '' "></h3>
        <h3 class="text-center text-primary openSans-bold" v-html=" focus.paragraphe2 ? focus.paragraphe2.titre : '' "></h3>
      </div>
    </div>
    <div class="row center my-5">
      <div class="col-12 col-md-6 mb-4 mb-md-3">
        <h2 class="text-primary" v-html=" focus.paragraphe3 ? focus.paragraphe3.titre : '' "></h2>
        <p v-html=" focus.paragraphe3 ? focus.paragraphe3.texte : '' "></p>
      </div>
      <div class="col-12 col-md-6 mb-5 mb-md-3">
         <h2 class="text-primary" v-html=" focus.paragraphe4 ? focus.paragraphe4.titre : '' "></h2>
        <p v-html=" focus.paragraphe4 ? focus.paragraphe4.texte : '' "></p>
      </div>
    </div>
    <div id="equipe" class="mx-auto d-flex flex-column flex-md-row w-100 justify-content-center">
      <div class="col-auto col-md-2"
            v-for="(collaborateur, idx) in collaborateurs"
            :key="idx">
        <figure class="figure collaborateur w-100 d-flex flex-column align-items-center">
          <img :src="collaborateur.image" :alt="collaborateur.poste" class="cover">
          <figcaption class="figure-caption">
            <h2 class="border-bottom border-primary text-dark text-center openSans-bold">{{ collaborateur.prenom }}</h2>
            <p class="text-dark text-center">{{ collaborateur.poste }}</p>
          </figcaption>
        </figure>
      </div>
    </div>
    <temoignage></temoignage>
  </div>
</template>

<script>
import { getFocus } from '../../mixins/getFocus'
import DataApi from 'fm-data-api'

export default {
  name: 'Equipe',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../components/ColorPointsHeader'),
    Temoignage: () => import('../../components/Temoignage.vue')
  },
  data () {
    return {
      greenHeaderMessage: {
        titre: '',
        sousTitre: ''
      },
      focus: [],
      collaborateurs: {}
    }
  },
  methods: {
    async loadCollaborateurs () {
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      this.dataApi.findRecords('W_Collaborateur', { 'col_SOC__Societe::d_nomSociete': 'CG Courtage' }, '', '', '')
        .then((response) => {
          this.insertCollaborateurs(response)
        })
    },
    insertCollaborateurs (collaborateursList) {
      if (collaborateursList.length > 0) {
        const collaborateursToInsert = {}
        collaborateursList.forEach(function (value, index) {
          const dataToInsert = value.fieldData
          dataToInsert.recordId = value.recordId
          collaborateursToInsert[dataToInsert.ordre] = dataToInsert
        })
        this.collaborateurs = collaborateursToInsert
      } else {
        this.collaborateurs = {}
      }
    }
  },
  async beforeMount () {
    await this.getFocus('CG Courtage', 'Équipe')
      .then(res => {
        this.focus = res
        this.greenHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
        this.greenHeaderMessage.sousTitre = this.focus.cartouche ? this.focus.cartouche.texte : ''
      })
  },
  created () {
    this.loadCollaborateurs()
  }
}

</script>
